enum FilterSelectLabel {
  Whitelabel = 'Whitelabel',
  Client = 'Client',
  Advertiser = 'Advertiser',
  Campaign = 'Campaign',
}

export default FilterSelectLabel;
